<question [title]="title" [description]="description" [valueOnly]="valueOnly">
  <div class="panel">
    <ion-segment *ngIf="!valueOnly" readonly [(ngModel)]="value" color="dark" (ionChange)="valueChanged()" class="likert">
      <ion-segment-button value="1"><ion-label>1</ion-label></ion-segment-button>
      <ion-segment-button value="2"><ion-label>2</ion-label></ion-segment-button>
      <ion-segment-button value="3"><ion-label>3</ion-label></ion-segment-button>
      <ion-segment-button value="4"><ion-label>4</ion-label></ion-segment-button>
      <ion-segment-button value="5"><ion-label>5</ion-label></ion-segment-button>
    </ion-segment>
    <ion-segment *ngIf="valueOnly" value="{{value}}" color="dark" class="likert">
      <ion-segment-button disabled value="1"><ion-label>1</ion-label></ion-segment-button>
      <ion-segment-button disabled value="2"><ion-label>2</ion-label></ion-segment-button>
      <ion-segment-button disabled value="3"><ion-label>3</ion-label></ion-segment-button>
      <ion-segment-button disabled value="4"><ion-label>4</ion-label></ion-segment-button>
      <ion-segment-button disabled value="5"><ion-label>5</ion-label></ion-segment-button>
    </ion-segment>
    <ion-grid *ngIf="hasLabels()">
      <ion-row>
        <ion-col size-sm="6">
          <ion-label class="ion-text-wrap">{{minLabel}}</ion-label>
        </ion-col>
        <ion-col size-sm="6" class="ion-text-right">
          <ion-label class="ion-text-right ion-text-wrap" style="text-align: right">{{maxLabel}}</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</question>
